import { isValidPostalCode, Province, Region } from '@nemuru-eng/js-api-client';
import { useFormContext } from 'react-hook-form';

export const useAutoUpdateProvinceAndRegion = (fieldNamesPrefix: string) => {
  const { watch, resetField, getValues } = useFormContext();

  const country = watch(`${fieldNamesPrefix}.country`);
  const postalCode = watch(`${fieldNamesPrefix}.postalCode`);

  const isSpanishAndValidPostalCode = country === 'ES' && isValidPostalCode(postalCode, 'ES');

  const updateProvinceAndRegionFromPostalCode = (postalCode) => {
    try {
      const province = Province.createFromPostalCode(postalCode);
      const region = Region.createFromPostalCode(postalCode);
      resetField(fieldNamesPrefix, {
        defaultValue: {
          ...getValues(fieldNamesPrefix),
          province: province.longName,
          provinceShortName: province.shortName,
          region: region.longName,
          regionShortName: region.shortName,
        },
        keepDirty: true,
      });
    } catch (error) {
      console.log(error);
    }
  };

  return {
    postalCode,
    country,
    updateProvinceAndRegionFromPostalCode,
    isSpanishAndValidPostalCode,
  };
};
